import { TSupplementResponseStatus } from '@interfaces/supplements';

import { IIdentity, ITableData } from './common';

export interface IMedicationDetails extends IIdentity {
  isAllowed: boolean;
  drugClassIds: number[];
  synonyms?: string[];
  rules?: {
    id: number;
    allowedIn: boolean;
    allowedOutside: boolean;
    administrations: {
      name: string;
      shortText: string;
      longText: string | null;
    }[];
    condition: string;
  }[];
}

export type IMedicationsSearchResult = ITableData<IMedicationDetails>;

export interface IMedicationSettings {
  bannedText: string;
  notBannedText: string;
  showMedicationExceptionLink: boolean;
  medicationExceptionFileUrl?: string;
  medicationExceptionFileName?: string;
}

export interface ISearchMedicationsProps {
  search: string;
  page: number;
}

export interface IImportMedicationsResponse {
  status: string;
  errors?: string[];
}

export interface IImportSynonymsListResponse {
  status: string;
  errors?: string[];
}

export interface IImportHighRiskSupplementsListResponse {
  status: string;
  errors?: string[];
}

export interface IImportSupplementsCleanUpListResponse {
  status: string;
  errors?: string[];
}

export interface IImportIngredientsCleanUpListResponse {
  status: string;
  errors?: string[];
}

export interface IUserEnteredMedicationImagesResponseDto {
  userEnteredMedicationDocumentId: number;
  origFileName: string;
  url: string;
}

export interface IUserEnteredMedicationResponseDto {
  id: number;
  name: string;
  productLink: string | null;
  images: IUserEnteredMedicationImagesResponseDto[];
}

export interface IUserEnteredMedicationData {
  name: string;
  productLink?: string | null;
  images?: IUserEnteredMedicationImagesResponseDto[];
}

export interface IUserEnteredMedication extends IUserEnteredMedicationData {
  id: number;
}

export type ICreateNewMedicationResponse = IIdentity;

export interface IMedicationInquiry {
  userEnteredMedicationId: number;
  medicationInquiryId: number;
  name: string;
  needsAdminResponse: boolean;
  respondedOn: string;
  submittedOn: string;
  supplementInquiryStatusId: TSupplementResponseStatus;
}

export interface IMedicationShareResponseDetails {
  comments: string;
  medicationInquiryId: number;
  name: string;
  productLink: string;
  supplementInquiryStatusId: number;
  userEnteredMedicationId: number;
}

export enum TAdminMedicationResponseType {
  NeedsInfo = 1,
}

export interface IMedicationResponse {
  userEnteredMedicationId: number;
  medicationInquiryId: number;
  name: string;
  supplementInquiryStatusId: TSupplementResponseStatus;
}

export interface IMedicationResponseDetails {
  medicationInquiryId: number;
  userEnteredMedicationId: number;
  name: string;
  supplementInquiryStatusId: number;
  productLink: string;
  comments: string;
}

export interface ISubmitMedicationNeedsInfoFormPayload {
  userEnteredMedicationId: number;
  name: string;
  linkToProductPage: string;
  note: string;
  images?: File[];
}

export enum MedicationFormFieldNames {
  Name = 'name',
  ProductLink = 'productLink',
  Comment = 'comment',
  Note = 'note',
  Images = 'images',
}

export enum MedicationServerFieldNames {
  Name = 'name',
  ProductLink = 'productLink',
  Comments = 'comments',
  Note = 'note',
  Images = 'images',
}
